module.exports = __webpack_public_path__ + "static/media/fidweb-testmystress-coming-soon.e7360888.png";